import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "preSaleCommPlan" }
const _hoisted_2 = { class: "tableHeader" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { style: {"margin-left":"8px"} }
const _hoisted_5 = { class: "handler" }
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-around"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", null, "删除", -1)
const _hoisted_9 = { class: "popup" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_13 = { style: {"position":"relative"} }
const _hoisted_14 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_15 = { style: {"position":"relative"} }
const _hoisted_16 = { style: {"height":"600px","overflow-y":"scroll","padding-top":"40px","position":"relative"} }
const _hoisted_17 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_18 = { style: {"flex":"1"} }
const _hoisted_19 = { style: {"flex":"1"} }
const _hoisted_20 = { style: {"flex":"1"} }
const _hoisted_21 = { class: "dia-container" }
const _hoisted_22 = { class: "flex25" }
const _hoisted_23 = { class: "dia-container" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "history"
}
const _hoisted_26 = { class: "method-title" }
const _hoisted_27 = { class: "new" }
const _hoisted_28 = { class: "footer" }

import { searchFormConfig } from './config/search.config'
import { computed, onMounted, reactive, ref, UnwrapRef, watch } from 'vue'
import 'dayjs/locale/zh-cn'
import dayjs from 'dayjs'
import {
  deletePageData,
  downloadData,
  editPageData,
  getListData,
  getPageListData
} from '@/service/main/system'
import type {
  ContextmenuPopupArg,
  STablePaginationConfig
} from '@surely-vue/table'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
import { useStore } from '@/store'
import { message } from 'ant-design-vue'
import localCache from '@/utils/cache'
import { ElMessage, ElMessageBox } from 'element-plus'
import { initEmptyParam } from '@/hooks/useInitParam'
import { Excel } from '@/utils/ExcelJs'
import { useRouter } from "vue-router";

interface DataItem {
  key: string
  custName: string
  attendClass: string
  corporation: string
  createTime: string
  createdBy: string

  deleted: string
  excellentStaff: string
  financingVolume: string
  followupSuggestion: string
  fund: string
  id: string
  introductionService: string
  managerAssistTracking: string
  quoteTimeAndAmount: string
  remarketing: string
  resistPoint: string
  resourceTime: string
  software: '√' | '×'
  stockPick: string
  teachers: string
  updateTime: string
  updatedBy: string
  weakness: string
}

const editUrl = '/main/preCommPlan518/save'

export default /*#__PURE__*/_defineComponent({
  __name: 'PreSaleCommPlan518',
  setup(__props) {

initEmptyParam()

const store = useStore()
const userInfo = store.state.login.userInfo

let queryParam = ref()
if (userInfo.isManager != '1') {
  queryParam.value = {
    empIds: userInfo.id,
    isEnd: ''
  }
} else {
  queryParam.value = {
    deptId: userInfo.deptId,
    isEnd: ''
  }
}
store.commit('system/changeQueyryInfo', queryParam.value)

dayjs.locale('zh-cn')

let count = 0
const preSalSearchRef = ref()
const today = dayjs(`${new Date()}`).format('YYYY-MM-DD')

const copyValue = (val: any) => {
  console.log('copyValue', val)
  const input = document.createElement('input')
  input.setAttribute('readonly', 'readonly')
  input.setAttribute('value', val)
  document.body.appendChild(input)
  input.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
    message.info('复制成功')
  }
  document.body.removeChild(input)
}
const copyClick = (
  args: ContextmenuPopupArg<any, any>,
  type: 'cell' | 'column' | 'record'
) => {
  if (type === 'cell') {
    if (args.column.key === 'operation') return
    copyValue(args.text)
  } else if (type === 'column') {
    if (args.column.key === 'operation') return
    const { dataIndex } = args.column
    copyValue(dataSource.value.map((d) => d[dataIndex]).join('\r\n'))
  } else {
    const record = args.record
    copyValue(
      columns
        .map((c: any) => (c.dataIndex ? record[c.dataIndex] : ''))
        .filter((c) => !!c)
        .join(' ')
    )
  }
  // 3.0.1 新增
  args.hidePopup()
}
const corpNames: any = ref([])
const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpName'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.name, value: item.name }
  })

  corpNames.value = roleData.map((item: any) => {
    return { label: item.name, value: item.name }
  })
}

getCompanyList()

const exploitPhase = [
  {
    value: '浅营销',
    label: '浅营销'
  },
  {
    value: '转营销',
    label: '转营销'
  },
  {
    value: '营销',
    label: '营销'
  },
  {
    value: '逼单',
    label: '逼单'
  }
]

const getEmp = async () => {
  let userList = await getListData('/main/employee/queryEmpList', {})
  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id + '' }
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'empIds'
  )
  userItem!.options = userOptions
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  dept!.isDisabled = userInfo.isManager != '1'
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const methodDialog = ref(false)
const managerMethods: any = ref([])
const getManagerMethods = async (record: any) => {
  managerMethods.value = await getListData(
    '/main/preCommPlan518/queryManagerMethods/' + record.id,
    {}
  )
  if (managerMethods.value.length == 0) {
    managerMethods.value = [
      {
        empName: record.empName,
        content: record.followupSuggestion,
        createdTime: record.updateTime
      }
    ]
  }
}
const planRecord: any = ref({})
const showMethod = (record: any) => {
  getManagerMethods(record)
  methodDialog.value = true
  planRecord.value = record
}

const txtMethod = ref('')
const showTextareaM = ref(false)
const addMethod = () => {
  showTextareaM.value = true
}

const saveMethod = () => {
  let body = {
    followupSuggestion: txtMethod.value,
    id: planRecord.value.id
  }
  editPageData('/main/preCommPlan518/managerMethods/save', body).then(() => {
    getManagerMethods(planRecord.value)
    initTable(pagination.value, queryParam.value)
    showTextareaM.value = false
    txtMethod.value = ''
  })
}

const deleteMethod = (id: string) => {
  deletePageData('/main/preCommPlan518/managerMethods/' + id).then(() => {
    getManagerMethods(planRecord.value)
    initTable(pagination.value, queryParam.value)
  })
}

const isCreatedToday = (createdTime: string, createdBy: string): boolean => {
  const createdAt = dayjs(createdTime, 'YYYY-MM-DD HH:mm:ss')
  const today = dayjs()
  return createdAt.isSame(today, 'day') && userInfo.id === createdBy
}

const recordDialog = ref(false)
const workerRecords: any = ref([])
const getWorkerRecords = async (record: any) => {
  workerRecords.value = await getListData(
    '/main/preCommPlan518/queryWorkerRecords/' + record.id,
    {}
  )
}
const planRecordR: any = ref({})
const showRecord = (record: any) => {
  getWorkerRecords(record)
  recordDialog.value = true
  planRecordR.value = record
}

const txtRecord = ref('')
const showTextareaR = ref(false)
const addRecord = () => {
  showTextareaR.value = true
}

const saveRecord = () => {
  let body = {
    followupCondition: txtRecord.value,
    id: currentDataRow.value.id
  }
  editPageData('/main/preCommPlan518/workerRecords/save', body).then(() => {
    getWorkerRecords(currentDataRow.value)
    initTable(pagination.value, queryParam.value)
    showTextareaR.value = false
  })
}

const deleteRecord = (id: string) => {
  deletePageData('/main/preCommPlan518/workerRecords/' + id).then(() => {
    getWorkerRecords(planRecordR.value)
    initTable(pagination.value, queryParam.value)
  })
}

const previewUpdateDialog = ref(false)
const userList = ref([])
const previewUpdate = () => {
  getUserList()
  previewUpdateDialog.value = true
}

const getUserList = () => {
  getListData('/main/preCommPlan518/getUserList', {}).then((res) => {
    userList.value = res
  })
}

const exportUserList = () => {
  let customHeader = ['姓名', '未更新客户数']
  let header = ['key', 'value']
  // 文件名
  let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
  const excel = new Excel()
  excel.exportExcel({
    name: '今日未更新名单-' + filename,
    title: '今日未更新名单-' + filename,
    data: userList.value,
    header,
    customHeader
  })
}

const pagination = ref<STablePaginationConfig>({
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: (total) => `共 ${totalSize.value} 条`,
  pageSize: 10,
  current: 1
})

const onDelete = (id: string, key: string, args?: any) => {
  if ('' == id) {
    dataSource.value = dataSource.value.filter((item) => item.key !== key)
  } else {
    deletePageData('/main/preCommPlan518/' + id).then(() => {
      initTable(pagination.value, queryParam.value)
    })
  }
  args?.hidePopup()
}

const handleAdd = (args?: any) => {
  const newData = {
    key: `${count}`,
    custName: '',
    corpName: '',
    attendClass: '',
    corporation: '',
    createTime: '',
    createdBy: '',
    deleted: '',
    excellentStaff: '',
    financingVolume: '',
    followupSuggestion: '',
    fund: '',
    id: '',
    introductionService: '',
    managerAssistTracking: '',
    quoteTimeAndAmount: '',
    remarketing: '',
    resistPoint: '',
    resourceTime: '',
    software: '',
    stockPick: '',
    teachers: '',
    updateTime: '',
    updatedBy: '',
    weakness: ''
  }
  count++
  dataSource.value.unshift(newData)
  dataSource.value = [].concat(dataSource.value)
  args?.hidePopup()
}

let totalSize = ref(0)

const handleSearchClick = (formdata: any) => {
  queryParam.value = formdata
  pagination.value.current = 1 //init page
  initTable(pagination.value, formdata)
}
const handleResetClick = () => {
  initTable(pagination.value, queryParam.value)
}

const dataSource = ref<DataItem[]>([])
const importAction =
  process.env.VUE_APP_BASE_URL + '/main/preCommPlan518/dataImport'

const headers = ref({})
const token = localCache.getCache('token')
headers.value = {
  Authorization: `Bearer ${token}`
}
const handleImportSuccess = (res: any) => {
  console.log(res)
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    initTable(pagination.value, queryParam.value)
    ElMessage({
      type: 'success',
      message: '导入成功'
    })
  }
}

const state = reactive<{
  selectedRowKeys: []
  loading: boolean
}>({
  selectedRowKeys: [], // Check here to configure the default column
  loading: false
})
const hasSelected = computed(() => state.selectedRowKeys.length > 0)
const selectedRowKeys = computed(() => state.selectedRowKeys)
const start = () => {
  state.loading = true
  // ajax request after empty completing
  setTimeout(() => {
    state.loading = false
    state.selectedRowKeys = []
  }, 1000)
}
const onSelectChange = (selectedRowKeys: []) => {
  console.log('selectedRowKeys changed: ', selectedRowKeys)
  state.selectedRowKeys = selectedRowKeys
}

const handleBatchDelete = () => {
  var pageNum = pagination.value.current || 1
  var pageSize = pagination.value.pageSize || 10
  ElMessageBox.confirm('确定要删除选中的数据吗', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    var ids = selectedRowKeys.value
      .map((o) => dataSource.value[(pageNum - 1) * pageSize + parseInt(o)].id)
      .join(',')
    deletePageData('/main/preCommPlan518/batch/' + ids).then(() => {
      initTable(pagination.value, queryParam.value)
      state.selectedRowKeys = []
      state.loading = false
    })
  })
}

const customHeaderCell = (column: any) => {
  const redArray = [
    'financingVolume',
    'historySign',
    'ownFunds',
    'age',
    'tradingTenure',
    'work',
    'operationalPreferences',
    'isTip',
    'weakness',
    'preferredCallTime',
    'excellentStaff',
    'corporation',
    'teachers',
    'hasTwiceYx',
    'stockPick',
    'stockPickMethod'
  ]
  const backArray = [
    'custName',
    'exploitAccount',
    'corpName',
    'resourceTime',
    'createTime',
    'updateTime',
    'empName',
    'deptName',
    'operation'
  ]
  if (redArray.indexOf(column.dataIndex) != -1) {
    return { style: { color: '#ff0000' } }
  }
  if (backArray.indexOf(column.dataIndex) != -1) {
    return {
      style: { fontWeight: 'bold' }
    }
  }
  if (column.title == '浅营销期') {
    return {
      style: { fontWeight: 'bold', backgroundColor: 'rgb(249,219,222)' }
    }
  }
  if (column.title == '转营销期') {
    return {
      style: { fontWeight: 'bold', backgroundColor: 'rgb(244,183,190)' }
    }
  }
  if (column.title == '营销期') {
    return {
      style: { fontWeight: 'bold', backgroundColor: 'rgb(239,147,158)' }
    }
  }
  if (column.title == '业务员') {
    return {
      style: { fontWeight: 'bold', backgroundColor: 'rgb(4,176,241)' }
    }
  }
  if (column.title == '经理工作') {
    return {
      style: { fontWeight: 'bold', backgroundColor: 'rgb(255,255,0)' }
    }
  }
  return {}
}

const handleImportError = (res: any) => {
  console.log(res)
}

const handleDownloadImport = () => {
  const fileName = '小单客户沟通计划表.xlsx'
  downloadData(
    '/main/preCommPlan518/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const handleExport = () => {
  let queryInfo = store.state.system.queryInfo
  getPageListData(
    '/main/preCommPlan518/download',
    {
      ...queryInfo
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    }) //处理文档流
    const down = document.createElement('a')
    down.download =
      '小单沟通计划表' +
      ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '') +
      '.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const initTable = (params: STablePaginationConfig = {}, query?: any) => {
  getPageListData('/main/preCommPlan518/queryByCondition', {
    ...query,
    pageNo: pagination.value.current,
    pageSize: pagination.value.pageSize
  }).then((res) => {
    dataSource.value = res.list
    totalSize.value = res.total
    count = dataSource.value.length
    pagination.value = {
      ...params,
      total: totalSize.value
    }
  })
}
onMounted(() => {
  initTable(pagination.value, queryParam.value)
})

watch(
  () => ({ ...pagination.value }),
  (cur, pre) => {
    if (cur.current !== pre.current || cur.pageSize !== pre.pageSize) {
      initTable(pagination.value, queryParam.value)
    }
  }
)

function getValueSetter() {
  return ({ record, column, row, newValue, oldValue }: any) => {
    let stack = new Error().stack
    if (stack.indexOf('handleKeyDown') != -1) {
      return true
    }
    let field = column.dataIndex
    let body = {}
    body[field] = newValue
    body['id'] = record.id
    editPageData(editUrl, body).then(() => {
      initTable(pagination.value, queryParam.value)
    })
    return true
  }
}

const columns = [
  {
    title: '客户',
    dataIndex: 'custName',
    type: 'input',
    autoHeight: true,
    editable: true,
    width: 90,
    align: 'center',
    resizable: true,
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '账号ID',
    dataIndex: 'exploitAccount',
    type: 'input',
    autoHeight: true,
    editable: true,
    width: 120,
    resizable: true,
    align: 'center',
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '企业微信主体',
    dataIndex: 'corpName',
    type: 'corpName',
    editable: 'cellEditorSlot',
    width: 240,
    align: 'center',
    resizable: true,
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '资源时间',
    dataIndex: 'resourceTime',
    type: 'date',
    width: 110,
    resizable: true,
    align: 'center',
    fixed: 'left',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot'
  },
  {
    title: '资金量',
    dataIndex: 'financingVolume',
    width: 80,
    type: 'input',
    resizable: true,
    align: 'center',
    fixed: 'left',
    valueSetter: getValueSetter(),
    editable: true
  },
  {
    title: '浅营销期',
    align: 'center',
    children: [
      {
        title: '自有资金',
        dataIndex: 'ownFunds',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '年龄',
        dataIndex: 'age',
        width: 100,
        type: 'input',
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      },
      {
        title: '签约经历(具体哪家公司)',
        dataIndex: 'historySign',
        type: 'input',
        autoHeight: true,
        editable: true,
        width: 100,
        align: 'center',
        resizable: true,
        valueSetter: getValueSetter()
      },
      {
        title: '工作',
        dataIndex: 'work',
        type: 'input',
        autoHeight: true,
        editable: true,
        width: 100,
        align: 'center',
        resizable: true,
        valueSetter: getValueSetter()
      },
      {
        title: '炒股年限',
        dataIndex: 'tradingTenure',
        width: 100,
        type: 'input',
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      },
      {
        title: '方便接听电话的时间',
        dataIndex: 'preferredCallTime',
        width: 100,
        type: 'input',
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      },
      {
        title: '2通1分钟以上的电话沟通',
        dataIndex: 'twoEffectivePhone',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '有过2次听课记录',
        dataIndex: 'hasTwice',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '对绩效点赞',
        dataIndex: 'customLike',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '公司塑造',
        dataIndex: 'corporation',
        type: 'select',
        width: 70,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '程超/孙腾/张进益/周培塑造',
        dataIndex: 'teachers',
        type: 'select',
        width: 70,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '选股塑造',
        dataIndex: 'stockPick',
        type: 'select',
        width: 70,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '客户选股方式',
        dataIndex: 'stockPickMethod',
        width: 100,
        type: 'input',
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      }
    ]
  },
  {
    title: '转营销期',
    align: 'center',
    children: [
      {
        title: '介绍服务和报价时间和金额',
        dataIndex: 'quoteTimeAndAmount',
        type: 'input',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      }
    ]
  },
  {
    title: '营销期',
    align: 'center',
    children: [
      {
        title: '抗拒点',
        dataIndex: 'resistPoint',
        type: 'textarea',
        width: 200,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        autoHeight: true,
        editable: 'cellEditorSlot'
      }
    ]
  },
  // {
  //   title: '业务员',
  //   align: 'center',
  //   children: [
  //     {
  //       title: '当日跟踪情况',
  //       dataIndex: 'followupCondition',
  //       type: 'textarea',
  //       width: 200,
  //       resizable: true,
  //       align: 'center',
  //       valueSetter: getValueSetter(),
  //       autoHeight: true
  //     }
  //   ]
  // },
  {
    title: '经理工作',
    align: 'center',
    children: [
      // {
      //   title: '经理给到的今日跟踪方案',
      //   dataIndex: 'followupSuggestion',
      //   type: 'textarea',
      //   width: 200,
      //   resizable: true,
      //   align: 'center',
      //   valueSetter: getValueSetter(),
      //   autoHeight: true
      // },
      {
        title: '客户开发阶段' + '（浅营销/转营销/营销/逼单）',
        dataIndex: 'exploitPhase',
        type: 'exploitPhase',
        width: 120,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      }
    ]
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    type: 'input',
    width: 180,
    align: 'center',
    autoHeight: true
  },
  {
    title: '修改时间',
    dataIndex: 'updateTime',
    type: 'input',
    width: 180,
    align: 'center',
    autoHeight: true
  },
  {
    title: '填报人',
    dataIndex: 'empName',
    type: 'input',
    width: 80,
    align: 'center',
    resizable: true,
    autoHeight: true
  },
  {
    title: '部门',
    dataIndex: 'deptName',
    type: 'input',
    width: 100,
    align: 'center',
    resizable: true,
    autoHeight: true
  },
  {
    title: '是否成交',
    dataIndex: 'isEnd',
    type: 'select',
    width: 100,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot',
    fixed: 'right'
  },
  {
    title: '操作',
    width: 200,
    resizable: true,
    key: 'operation',
    align: 'center',
    dataIndex: 'operation',
    fixed: 'right'
  }
]
const editableData: UnwrapRef<Record<string, DataItem>> = reactive({})


// 2024-12-2 变更
const activeNames = ref(['1','浅营销期','转营销期','营销期','经理工作','3'])
const router = useRouter()
const modalDialog = ref(false)
const modalTitle = ref('')
const currentDataRow: any = ref({})
const handleFillClick = () => {
  modalTitle.value = '新增'
  currentDataRow.value = {}
  modalDialog.value = true
  workerRecords.value = []
}

const handleEdit = (item: any) => {
  modalTitle.value = '编辑'
  currentDataRow.value = { ...item }
  modalDialog.value = true
  getWorkerRecords(item)
}


const saveData = () => {
  console.log(111111111111111)
  editPageData(editUrl, currentDataRow.value).then(() => {
    modalDialog.value = false
    initTable(pagination.value, queryParam.value)
  })

}

const cancel = () => {
  modalDialog.value = false
  showTextareaR.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_copy_outlined = _resolveComponent("copy-outlined")!
  const _component_s_table = _resolveComponent("s-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      ref: preSalSearchRef.value,
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: handleResetClick,
      onSearchBtnClick: handleSearchClick
    }, null, 8, ["searchFormConfig"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "default",
          size: "medium",
          loading: state.loading,
          onClick: start
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消全选")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createElementVNode("span", _hoisted_4, [
          (hasSelected.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(`已选中 ${selectedRowKeys.value.length} 行`), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleFillClick
        }, {
          default: _withCtx(() => [
            _createTextVNode("新增")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleBatchDelete
        }, {
          default: _withCtx(() => [
            _createTextVNode("批量删除")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleDownloadImport
        }, {
          default: _withCtx(() => [
            _createTextVNode("模板下载")
          ]),
          _: 1
        }),
        _createVNode(_component_el_upload, {
          style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
          action: importAction,
          headers: headers.value,
          accept: ".xls,.xlsx",
          "on-success": handleImportSuccess,
          "on-error": handleImportError,
          "show-file-list": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              size: "medium",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("数据导入")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["headers"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleExport
        }, {
          default: _withCtx(() => [
            _createTextVNode("数据导出")
          ]),
          _: 1
        }),
        (_unref(userInfo).isManager == '1')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "medium",
              onClick: previewUpdate
            }, {
              default: _withCtx(() => [
                _createTextVNode("今日未更新名单")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_s_table, {
      bordered: "",
      "data-source": dataSource.value,
      columns: columns,
      stripe: "",
      pagination: pagination.value,
      "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((pagination).value = $event)),
      sticky: "",
      scroll: { x: 2000 },
      "show-header-scrollbar": "",
      "auto-header-height": "",
      "row-selection": {
        selectedRowKeys: selectedRowKeys.value,
        onChange: onSelectChange
      },
      "custom-header-cell": customHeaderCell
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("a", {
                onClick: ($event: any) => (handleEdit(record))
              }, "编辑", 8, _hoisted_7),
              (dataSource.value.length)
                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                    key: 0,
                    title: "确定要删除吗?",
                    onConfirm: ($event: any) => (onDelete(record.id, record.key))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      cellEditor: _withCtx(({ column, modelValue, save, closeEditor, editorRef }) => [
        (column.type === 'date')
          ? (_openBlock(), _createBlock(_component_a_date_picker, {
              key: 0,
              locale: _unref(locale),
              ref: editorRef,
              bordered: false,
              value: 
              _unref(dayjs)(
                modelValue.value
                  ? modelValue.value
                  : _unref(dayjs)(`${new Date()}`).format('YYYY-MM-DD')
              )
            ,
              style: {"width":"100%"},
              open: "",
              "allow-clear": false,
              "onUpdate:value": 
              (v) => {
                modelValue.value = v?.format('YYYY-MM-DD') ?? ''
                save()
              }
            ,
              onBlur: closeEditor,
              onKeydown: _withKeys(closeEditor, ["esc"]),
              onClick: _withModifiers(closeEditor, ["stop"])
            }, null, 8, ["locale", "value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
          : (column.type === 'select')
            ? (_openBlock(), _createBlock(_component_a_select, {
                key: 1,
                ref: editorRef,
                bordered: true,
                value: modelValue.value,
                style: {"width":"120px"},
                options: [
              {
                value: '√',
                label: '√'
              },
              {
                value: '×',
                label: '×'
              }
            ],
                open: "",
                "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                onBlur: closeEditor,
                onKeydown: _withKeys(closeEditor, ["esc"]),
                onClick: _withModifiers(closeEditor, ["stop"])
              }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
            : (column.type === 'corpName')
              ? (_openBlock(), _createBlock(_component_a_select, {
                  key: 2,
                  ref: editorRef,
                  bordered: true,
                  value: modelValue.value,
                  style: {"width":"240px"},
                  options: corpNames.value,
                  open: "",
                  "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                  onBlur: closeEditor,
                  onKeydown: _withKeys(closeEditor, ["esc"]),
                  onClick: _withModifiers(closeEditor, ["stop"])
                }, null, 8, ["value", "options", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
              : (column.type === 'exploitPhase')
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 3,
                    ref: editorRef,
                    bordered: true,
                    value: modelValue.value,
                    style: {"width":"120px"},
                    options: [
              {
                value: '浅营销',
                label: '浅营销'
              },
              {
                value: '转营销',
                label: '转营销'
              },
              {
                value: '营销',
                label: '营销'
              },
              {
                value: '逼单',
                label: '逼单'
              }
            ],
                    open: "",
                    "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                    onBlur: closeEditor,
                    onKeydown: _withKeys(closeEditor, ["esc"]),
                    onClick: _withModifiers(closeEditor, ["stop"])
                  }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
                : (column.type == 'textarea')
                  ? (_openBlock(), _createBlock(_component_a_textarea, {
                      key: 4,
                      ref: editorRef,
                      bordered: true,
                      value: modelValue.value,
                      autosize: "true",
                      "onUpdate:value": 
              (v) => {
                modelValue.value = v
              }
            ,
                      onBlur: save,
                      onKeydown: _withKeys(closeEditor, ["esc"])
                    }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown"]))
                  : _createCommentVNode("", true)
      ]),
      contextmenuPopup: _withCtx((args) => [
        _createElementVNode("ul", _hoisted_9, [
          _createElementVNode("li", {
            class: _normalizeClass(["popup-item", args.column.key === 'operation' && 'disabled']),
            onClick: ($event: any) => (handleAdd(args))
          }, [
            _createVNode(_component_copy_outlined),
            _createTextVNode(" 添加一行 ")
          ], 10, _hoisted_10),
          _createElementVNode("li", {
            class: _normalizeClass(["popup-item", args.column.key === 'operation' && 'disabled']),
            onClick: ($event: any) => (onDelete(args.record.id, args.record.key, args))
          }, [
            _createVNode(_component_copy_outlined),
            _createTextVNode(" 删除 ")
          ], 10, _hoisted_11)
        ])
      ]),
      _: 1
    }, 8, ["data-source", "pagination", "row-selection"]),
    _createVNode(_component_el_dialog, {
      modelValue: methodDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((methodDialog).value = $event)),
      title: "跟踪方案",
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_timeline, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_timeline_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  (!showTextareaM.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        style: {"height":"36px","margin-right":"15px"},
                        type: "primary",
                        size: "medium",
                        onClick: addMethod
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showTextareaM.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        style: {"height":"36px","margin-right":"15px"},
                        type: "primary",
                        size: "medium",
                        onClick: saveMethod
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("保存")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showTextareaM.value)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 2,
                        type: "textarea",
                        rows: 2,
                        placeholder: "请输入内容",
                        modelValue: txtMethod.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((txtMethod).value = $event))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_input, {
                    type: "hidden",
                    modelValue: _ctx.planId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.planId) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerMethods.value, (mtd, index) => {
              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                timestamp: mtd.createdTime,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        (isCreatedToday(mtd.createdTime, mtd.createdBy))
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "danger",
                              size: "small",
                              style: {"position":"absolute","right":"0","top":"0"},
                              onClick: ($event: any) => (deleteMethod(mtd.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("删除")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("h4", null, _toDisplayString(mtd.content), 1),
                        _createElementVNode("p", null, _toDisplayString(mtd.empName), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["timestamp"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: recordDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((recordDialog).value = $event)),
      title: "跟踪记录",
      width: "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_timeline, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_timeline_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  (!showTextareaR.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        style: {"height":"36px","margin-right":"15px"},
                        type: "primary",
                        size: "medium",
                        onClick: addRecord
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showTextareaR.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        style: {"height":"36px","margin-right":"15px"},
                        type: "primary",
                        size: "medium",
                        onClick: saveRecord
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("保存")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (showTextareaR.value)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 2,
                        type: "textarea",
                        rows: 2,
                        placeholder: "请输入内容",
                        modelValue: txtRecord.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((txtRecord).value = $event))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_input, {
                    type: "hidden",
                    modelValue: _ctx.planId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.planId) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workerRecords.value, (mtd, index) => {
              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                timestamp: mtd.createdTime,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    (isCreatedToday(mtd.createdTime, mtd.createdBy))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "danger",
                          size: "small",
                          style: {"position":"absolute","right":"0","top":"0"},
                          onClick: ($event: any) => (deleteRecord(mtd.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("h4", null, _toDisplayString(mtd.content), 1),
                    _createElementVNode("p", null, _toDisplayString(mtd.empName), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["timestamp"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "30%",
      modelValue: previewUpdateDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((previewUpdateDialog).value = $event)),
      title: "今日未更新名单"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_button, {
            style: {"position":"absolute","right":"0","top":"0"},
            type: "primary",
            size: "medium",
            onClick: exportUserList
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (user, index) => {
            return (_openBlock(), _createBlock(_component_el_card, { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, "姓名：" + _toDisplayString(user.name), 1),
                  _createElementVNode("div", _hoisted_19, "未更新客户数量：" + _toDisplayString(user.notUpdated), 1),
                  _createElementVNode("div", _hoisted_20, "总数量：" + _toDisplayString(user.total), 1)
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "80%",
      modelValue: modalDialog.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((modalDialog).value = $event)),
      title: modalTitle.value,
      top: "2vh"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "dialog-parent" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, {
              modelValue: activeNames.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((activeNames).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, {
                  title: "基本信息",
                  name: "1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.filter(item => !item.children && item.editable), (item) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (item.type === 'input')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: item.title
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: currentDataRow.value[item.dataIndex],
                                    "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[item.dataIndex]) = $event),
                                    clearable: "",
                                    placeholder: "请输入"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            : (item.type === 'textarea')
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 1,
                                  label: item.title
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      type: "textarea",
                                      modelValue: currentDataRow.value[item.dataIndex],
                                      "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[item.dataIndex]) = $event),
                                      clearable: "",
                                      placeholder: "请输入"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              : (item.type === 'select')
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 2,
                                    label: item.title
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: currentDataRow.value[item.dataIndex],
                                        "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[item.dataIndex]) = $event),
                                        placeholder: "请选择",
                                        clearable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "√",
                                            value: "√"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "×",
                                            value: "×"
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                : (item.type === 'date')
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 3,
                                      label: item.title
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: currentDataRow.value[item.dataIndex],
                                          "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[item.dataIndex]) = $event),
                                          type: "date",
                                          placeholder: "选择日期",
                                          clearable: ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  : (item.type === 'corpName')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 4,
                                        label: item.title
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: currentDataRow.value[item.dataIndex],
                                            "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[item.dataIndex]) = $event),
                                            placeholder: "请选择",
                                            clearable: "",
                                            filterable: ""
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(corpNames.value, (corp, index) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: index,
                                                  label: corp.label,
                                                  value: corp.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    : _createCommentVNode("", true)
                        ]))
                      }), 256))
                    ])
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.filter(item => item.children), (item) => {
                  return (_openBlock(), _createBlock(_component_el_collapse_item, {
                    title: item.title,
                    name: item.title,
                    class: "flex100"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (child.type === 'input')
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  label: child.title
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: currentDataRow.value[child.dataIndex],
                                      "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                      clearable: "",
                                      placeholder: "请输入"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              : (child.type === 'textarea')
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 1,
                                    label: child.title
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        type: "textarea",
                                        modelValue: currentDataRow.value[child.dataIndex],
                                        "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                        clearable: "",
                                        placeholder: "请输入"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                : (child.type === 'select')
                                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                                      key: 2,
                                      label: child.title
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: currentDataRow.value[child.dataIndex],
                                          "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                          placeholder: "请选择",
                                          clearable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              label: "√",
                                              value: "√"
                                            }),
                                            _createVNode(_component_el_option, {
                                              label: "×",
                                              value: "×"
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  : (child.type === 'date')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 3,
                                        label: child.title
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_date_picker, {
                                            modelValue: currentDataRow.value[child.dataIndex],
                                            "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                            type: "date",
                                            placeholder: "选择日期",
                                            clearable: ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    : (child.type === 'corpName')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 4,
                                          label: child.title
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: currentDataRow.value[child.dataIndex],
                                              "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                              placeholder: "请选择",
                                              clearable: "",
                                              filterable: ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(corpNames.value, (corp, index) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: index,
                                                    label: corp.label,
                                                    value: corp.value
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 2
                                        }, 1032, ["label"]))
                                      : (child.type === 'exploitPhase')
                                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 5,
                                            label: child.title
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_select, {
                                                modelValue: currentDataRow.value[child.dataIndex],
                                                "onUpdate:modelValue": ($event: any) => ((currentDataRow.value[child.dataIndex]) = $event),
                                                placeholder: "请选择",
                                                clearable: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(exploitPhase, (col, index) => {
                                                    return _createVNode(_component_el_option, {
                                                      key: index,
                                                      label: col.label,
                                                      value: col.value
                                                    }, null, 8, ["label", "value"])
                                                  }), 64))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title", "name"]))
                }), 256)),
                _createVNode(_component_el_collapse_item, {
                  title: "跟踪记录",
                  name: "3"
                }, {
                  default: _withCtx(() => [
                    (currentDataRow.value.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (workerRecords.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workerRecords.value, (rtd, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    style: {"text-align":"left"}
                                  }, [
                                    _createElementVNode("div", _hoisted_26, _toDisplayString(rtd.createdTime + " " + rtd.empName + " " + rtd.content), 1)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_27, [
                            (!showTextareaR.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  style: {"height":"36px","margin-right":"15px","float":"right"},
                                  type: "primary",
                                  size: "medium",
                                  onClick: addRecord
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("新增")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (showTextareaR.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  style: {"height":"36px","margin-right":"15px","float":"right"},
                                  type: "primary",
                                  size: "medium",
                                  onClick: saveRecord
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("保存")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (showTextareaR.value)
                              ? (_openBlock(), _createBlock(_component_el_input, {
                                  key: 2,
                                  type: "textarea",
                                  rows: 2,
                                  placeholder: "请输入内容",
                                  modelValue: txtRecord.value,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((txtRecord).value = $event))
                                }, null, 8, ["modelValue"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_input, {
                              type: "hidden",
                              modelValue: currentDataRow.value.id,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentDataRow.value.id) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: saveData
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提交")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: cancel }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})